export const sectionSpecificStyles = {
  empty_section: {
    sectionStyle: {},
    cardStyle: () => ({}),
  },
  uniform_grid_section: {
    sectionStyle: {
      display: 'flex',
      justifyContent: 'flex-start',
      flexWrap: 'wrap',
      flex: 1,
    },
    cardStyle: () => ({
      margin: 25,
      flex: 1,
      maxWidth: '50%',
      minWidth: '30%',
    }),
  },
  grid_section: {
    sectionStyle: {
      display: 'flex',
      justifyContent: 'flex-start',
      flexWrap: 'wrap',
      flex: 1,
    },
    cardStyle: () => ({
      // margin: 'auto',
      width: '20%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      margin: '16px 0px',
    }),
  },
  section_with_filters: {
    sectionStyle: {
      display: 'flex',
      justifyContent: 'flex-start',
      flexWrap: 'wrap',
      flex: 1,
    },
    cardStyle: () => ({
      margin: 25,
      flex: 1,
      maxWidth: '50%',
      minWidth: '30%',
    }),
  },
  background_section: {
    sectionStyle: {
      padding: '0 15px 10px 15px',
    },
    cardStyle: () => ({
      background: '#F7F7F7 0% 0% no-repeat padding-box',
      borderRadius: '5px',
      padding: '5px',
    }),
  },
  extreme_aligned_grid_section: {
    sectionStyle: {
      padding: '10px',
      display: 'flex',
      justifyContent: 'space-between',
      flexWrap: 'wrap',
    },
    cardStyle: () => ({}),
  },
  two_level_title_section: {
    sectionStyle: {
      display: 'flex',
      justifyContent: 'flex-start',
      flexWrap: 'wrap',
    },
    cardStyle: () => ({
      margin: 20,
    }),
  },
  grid_list_section: {
    sectionStyle: {
      display: 'grid',
      gridTemplateColumns: 'calc(50% - 20px) calc(50% - 20px)',
      gridGap: 40,
    },
    cardStyle: (card_type) => getCardStyles(card_type),
  },
  card_heading_subtitle: {
    sectionStyle: {
      display: 'flex',
      justifyContent: 'flex-start',
      flexWrap: 'wrap',
      flex: 1,
    },
    cardStyle: () => ({
      // margin: 'auto',
      width: '20%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      margin: '16px 0px',
    }),
  },
  section_with_heading_and_see_more: {
    sectionStyle: {
      display: 'flex',
      justifyContent: 'flex-start',
      flexWrap: 'wrap',
      flex: 1,
    },
    cardStyle: () => ({
      // margin: 'auto',
      width: '20%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      margin: '16px 0px',
      padding: 20,
      marginTop: 15,
    }),
  },
};

const getCardStyles = (card_type) => {
  const card_styles = {
    card_118: {
      gridRow: 'span 2',
    },
    card_121: {
      gridRow: 'span 2',
    },
  };

  return card_styles[card_type];
};
